import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ExportDownloadResponse } from '@api-response-types/export-download.response';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { triggerLinkDownload } from 'common/export-helper';
import { AnalysisMutationsService } from 'demand-forecasting/analysis/services/analysis-mutations.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, firstValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AnalysisExportService {
  private readonly http = inject(HttpClient);
  private readonly analysisMutationsService = inject(AnalysisMutationsService);
  private readonly toastService = inject(ToastrService);
  private readonly translate = inject(TranslateService);

  startExport(selectedVersionId: string) {
    return this.analysisMutationsService.generateExport(selectedVersionId).pipe(
      map(() => {
        this.toastService.success(
          this.translate.instant('ANALYSIS.EXPORT.TOAST_STARTED'),
        );
      }),
      catchError((error) => {
        this.toastService.error(
          this.translate.instant('ANALYSIS.EXPORT.FAILED'),
        );
        return error;
      }),
    );
  }

  public async downloadSelectedExport(exportId: string): Promise<void> {
    if (!exportId) {
      console.error('No export selected when trying to download export');
      return;
    }

    try {
      const downloadData = await firstValueFrom(
        this.http.get<ExportDownloadResponse>(
          `${environment.api.url}/analysis-exports/${exportId}`,
        ),
      );
      triggerLinkDownload(downloadData.downloadLink, downloadData.fileName);
    } catch {
      this.toastService.error(
        this.translate.instant('ANALYSIS.EXPORT.DOWNLOAD_FAILED'),
      );
    }
  }
}
